export default __webpack_public_path__ + "static/media/cta.005e1aad.png";